import ColorUI from "@ckeditor/ckeditor5-font/src/ui/colorui"
import icon from "@ckeditor/ckeditor5-font/theme/icons/font-color.svg"
import { UNDERLINE_COLOR } from "./utils"

export default class UnderlineColorUI extends ColorUI {
  constructor(editor) {
    const t = editor.locale.t
    super(editor, {
      commandName: UNDERLINE_COLOR,
      componentName: UNDERLINE_COLOR,
      icon: icon,
      dropdownLabel: t("Underline Color"),
    })
  }

  static get pluginName() {
    return "UnderlineColorUI"
  }
}
